export const reduxConstants = {
  MODIFY_CONSENT_PRIVACY_POLICY: 'modify_consent_privacy_policy',
  MODIFY_PRIVACY_POLICY_CONSENT_DATA: 'modify_privacy_policy_consent_data',
};
